import { countries } from '../../labels/countries';

export default function isCountryCode(value?: string): boolean {
  if (!value) {
    return false;
  }

  return !!countries.find((country) => country.code === value);
}
